// 261010 P8e — dời nguyên văn `usePrep` từ FilmBankTab. Không antd ⇒ jest chạy được. Comment "6 lượt GET" là cũ (thực tế 7).
import { useEffect, useState } from 'react';
import { filmApi } from '../../services/api/film';
import { bankPrep, type BankPrep } from './bankPrepUtils';
import { readDismissed } from './castDismiss';
import { takeWorkflowHandoff as take } from '../../services/api/workflowReadHandoff';
import { AK } from './workflowAssetsPreload';

/**
 * Tải dữ liệu cho dòng chuẩn bị — 6 lượt GET nhẹ, song song. Hỏng ⇒ `null` (dòng ẩn), không làm hỏng drawer.
 * `key` đổi (tab con báo `onChanged`) ⇒ tải lại.
 */
export function useBankPrep(storyId: string, planId: string | undefined, key: number): BankPrep | null {
  const [prep, setPrep] = useState<BankPrep | null>(null);
  useEffect(() => {
    if (!planId) { setPrep(null); return; }
    let alive = true;
    // 261029 P3 F1: lần nạp ĐẦU lấy từ chỗ giao một lần (đọc sớm), các lần sau (key đổi sau thao tác ghi) chỗ giao đã trống/hết hạn ⇒ gọi mới.
    Promise.all([
      take(AK.chars(storyId), () => filmApi.listCharacters(storyId)), take(AK.looks(storyId), () => filmApi.listLooks(storyId)), take(AK.sceneLooks(planId), () => filmApi.sceneLooks(planId)),
      take(AK.locations(storyId), () => filmApi.listLocations(storyId)), take(AK.props(storyId), () => filmApi.listProps(storyId)), take(AK.bankUsage(planId), () => filmApi.bankUsage(planId)).catch(() => null),
      // 260922 E1-P2: người trong event chưa có hồ sơ — trừ mục người vận hành đã "Bỏ qua" (nhớ ở trình duyệt).
      take(AK.castCandidates(planId), () => filmApi.castCandidates(planId)).catch(() => ({ candidates: [] as { key: string }[] })),
    ]).then(([chars, looks, sceneRows, locations, props, usage, cands]) => {
      const dismissed = new Set(readDismissed(storyId));
      const castCandidates = (cands.candidates || []).filter((c) => !dismissed.has(c.key)).length;
      if (alive) setPrep(bankPrep({ chars, looks, sceneRows, locations, props, usage, castCandidates }));
    }).catch(() => { if (alive) setPrep(null); });
    return () => { alive = false; };
  }, [storyId, planId, key]);
  return prep;
}
